
import axios from 'axios';


import {UserAction, DesignerAction, ProductAction, RedeemAction, OrderAction} from 'AppAction';

import SessionStore from 'stores/SessionStore';
import Dispatcher from 'service/Dispatcher';

import AppConstants from 'AppConstants';
import AppUtil from '../AppUtil';

const PROJECT_NAME = AppConstants.APP_NAME;


const BITLY_API = axios.create({baseURL: 'https://api-ssl.bit.ly/v3/', timeout: 300000});

export class HttpService {
	constructor(baseUrl) {
		this.axios = axios.create({
			baseURL: baseUrl,
			timeout: 900000
		});

		this.afterLoginCallback = null;
		this.defaultErrorHandler = this.defaultErrorHandler.bind(this);

		this.saveAfterLoginCallback = this.saveAfterLoginCallback.bind(this);
	}

	redirect(url) {
		//TODO: figure out a better way to do it
		window.location.href = url;
	}


	saveAfterLoginCallback(callback) {
		this.afterLoginCallback = callback;
	}

	defaultErrorHandler(error) {
		console.log("UI Error", error);
		
		if(error.response)
			Dispatcher.dispatchAnAlert(error.response.data);
		else if (error.message === "Network Error")
			Dispatcher.dispatchAnAlert({message: "NETWORK ERROR: Could not connect to the server. Please try again later.", type: "ERROR"});
		else if (error.message.indexOf("timeout") >= 0)
			Dispatcher.dispatchAnAlert({message: "TIMEOUT ERROR: Could not fetch your data. Please try again later.", type: "ERROR"});
		else if (error.message)
			Dispatcher.dispatchAnAlert({message: error.message, type: "ERROR"});

		if(error.response) {
			if(error.response.status === 401) {
				this.logout();
				Dispatcher.dispatchAlertWithAction(AppConstants.LOGIN_TO_CONTINUE_MSG, "WARN");
			} else if(error.response.status === 404) {
				this.redirect("/404");
			}
		}
		
	}

	get(url, onSuccess, onError) {
		let errorHandler = onError || this.defaultErrorHandler;

		this.axios({
			url: url,
			method: 'get',
			headers: this.getHeaders()
		}).then(onSuccess).catch(errorHandler);
	}

	post(url, postData, onSuccess, onError) {
		let errorHandler = onError || this.defaultErrorHandler.bind(this);
		this.axios({
			url: url,
			method: 'post',
			data: postData,
			headers: this.getHeaders()
		}).then(onSuccess).catch(errorHandler);
	}

	postFormData(url, postData, onSuccess, onError) {
		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		let errorHandler = onError || this.defaultErrorHandler.bind(this);
		this.axios({
			url: url,
			method: 'post',
			data: postData,
			headers: headers
		}).then(onSuccess).catch(errorHandler);
	}


	delete(url, onSuccess, onError) {
		let errorHandler = onError || this.defaultErrorHandler;
		this.axios({
			url: url,
			method: 'delete',
			headers: this.getHeaders()
		}).then(onSuccess).catch(errorHandler);
	}

	getHeaders() {
		let headers = {'Accept':'application/json', 'Content-Type':'application/json'};

		const session = SessionStore.getCurrentSession();
		if(session !== null)
			headers['Authorization'] = 'Bearer '+session.token;

		return headers;
	}


	login(email, password, callback) {
		const loginData = {'password': btoa(password)};
		if(AppUtil.startsWithNumber(email)) {
			loginData['phoneNumber'] = email;
			loginData['loginType'] = "PHONE_LOGIN";
		} else {
			loginData['email'] = email;
			loginData['loginType'] = "REGULAR";
		}
		
		this.doLogin(loginData, callback);
	}

	loginWithFB(accessToken, callback) {
		const data = {'fbAccessToken': accessToken, 'loginType': 'FB_CONNECT'};
		this.doLogin(data, callback);
	}

	loginWithGEmail(idToken, callback) {
		const data = {'gmailIdToken': idToken, 'loginType': 'GMAIL_SIGN_IN'};
		this.doLogin(data, callback);
	}

	doLogin(loginRequest, callback) {
		this.post("/user/login", loginRequest, response => {
			const bearerToken = response.data['bearer'];
			const user = response.data['user'];
			const expiresOn = response.data['expiresOn'];

			Dispatcher.dispatch({
				type: UserAction.LOGIN_SUCCESS,
				user: user,
				token: bearerToken,
				expiresOn: expiresOn
			});

			//call any callback if saved
			if(typeof this.afterLoginCallback === "function") {
				this.afterLoginCallback();
				this.afterLoginCallback = null;
			}
			

			if(loginRequest.loginType === 'SIGNUP_AND_LOGIN') {
				if(loginRequest.email)
					Dispatcher.dispatchAlertWithAction("Your "+PROJECT_NAME+" account has been created. Do verify your email by following the instruction sent to '"+loginRequest.email+"'.", "INFO", "LOGGED_IN");
				else
					Dispatcher.dispatchAlertWithAction("Your "+PROJECT_NAME+" account has been created.", "INFO", "LOGGED_IN");
			}
				

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			if(typeof callback === 'function') {
				if(error.response) {
					callback(false, error.response.data);
				} else {
					callback(false, error);
				}
			}
				
		});
		
	}

	logout() {
		Dispatcher.dispatch({
			type: UserAction.LOGOUT
		});	
	}

	getUserBasicInfo(storeName, userId) {
		let url = "/user/profile/basic";

		if(storeName) url+= "?storeName="+storeName;
		else if(userId) url+= "?userId="+userId;

		this.get(url, response => {
			Dispatcher.dispatch({
				type: UserAction.LOAD_USER_PROFILE,
				userInfo: response.data,
				storeName: storeName,
				userId: userId
			});
		})
	}

	updateUserInfo(userInfo, callback) {
		this.post("/user/userinfo", userInfo, response => {
			const updatedUser = response.data['user'];
			Dispatcher.dispatch({
				type: UserAction.LOGIN_SUCCESS,
				user: updatedUser,
				token: response.data['bearer'],
				expiresOn: response.data['expiresOn']

			});

			Dispatcher.dispatch({
				type: UserAction.LOAD_USER_PROFILE,
				userInfo: updatedUser,
				storeName: updatedUser.storeName,
				userId: updatedUser.id
			});

			Dispatcher.dispatchAnAlert("Your account info updated successfully.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false);
		});

	}

	upgradeToDesigner(callback) {
		this.post("/designer/upgrade", null, response => {
			Dispatcher.dispatch({
				type: UserAction.LOGIN_SUCCESS,
				user: response.data['user'],
				token: response.data['bearer'],
				expiresOn: response.data['expiresOn']
			});

			callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false);
		});
	}


	updatePhone(phoneNumber, callback) {
		this.post("/user/phone?number="+phoneNumber, null, response => {
			Dispatcher.dispatch({
				type: UserAction.PHONE_UPDATE,
				phoneNumber: phoneNumber
			});

			Dispatcher.dispatchAnAlert(response.data);
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

	addProduct(addProductRequestJson, previewImage, productImages, callback) {
		let formData = new FormData();
		formData.append("addProductRequestJson", JSON.stringify(addProductRequestJson));

		if(previewImage)
			formData.append("previewImageFile", previewImage);

		for(var i = 0;i < productImages.length;i++) {
			var productImage = productImages[i];

			formData.append("productImagesFile", productImage);
		}

		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/product/add",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			const user = SessionStore.getCurrentSession().user;
			Dispatcher.dispatch({
				type: ProductAction.UPLOAD_NEW_PRODUCT,
				userId: user.id
			});

			Dispatcher.dispatchAnAlert("Product added successfully. Our team will verify your design and will contact you soon.");
			callback(true);
		}).catch(response => {
			callback(false);
			this.defaultErrorHandler(response);
		});
	}

	addSubProduct(addSubProductRequestJson, productImages, callback) {
		let formData = new FormData();
		formData.append("addSubProductRequestJson", JSON.stringify(addSubProductRequestJson));

		for(var i = 0;i < productImages.length;i++) {
			var productImage = productImages[i];
			formData.append("productImagesFile", productImage);
		}

		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/product/add/subproduct",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			const user = SessionStore.getCurrentSession().user;
			Dispatcher.dispatch({
				type: ProductAction.UPLOAD_NEW_PRODUCT,
				userId: user.id
			});

			Dispatcher.dispatchAnAlert("Product added successfully.");
			callback(true);
		}).catch(response => {
			callback(false);
			this.defaultErrorHandler(response);
		});
	}

	getProduct(productId) {
		this.get("/product/"+productId, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});
		})
	}

	updateProductInfo(productId, product, callback) {
		this.post("/product/"+productId, product, response => {

			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});
				
			Dispatcher.dispatchAnAlert("Product Information Updated successfully.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		})
	}

	updatePreviewImage(productId, newImage, callback) {
		let formData = new FormData();
		formData.append("newImageFile", newImage);
		
		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/product/"+productId+"/updatePreviewImage",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});

			Dispatcher.dispatchAnAlert("Preview Image Modified Successfully.");
			callback(true);
		}).catch(response => {
			this.defaultErrorHandler(response);
			callback(false);
		});

	}

	updateProductImage(productId, imageUrl, newImage, callback) {
		let formData = new FormData();
		formData.append("currentImageUrl", imageUrl);
		formData.append("newImageFile", newImage);
		
		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/product/"+productId+"/updateImage",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});

			Dispatcher.dispatchAnAlert("Product Image Modified Successfully.");
			callback(true);
		}).catch(response => {
			this.defaultErrorHandler(response);
			callback(false);
		});

	}

	addNewProductImage(productId, newImage, callback) {
		let formData = new FormData();
		formData.append("newImageFile", newImage);
		
		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/product/"+productId+"/addImage",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});

			Dispatcher.dispatchAnAlert("Product Image Uploaded Successfully.");
			callback(true);
		}).catch(response => {
			this.defaultErrorHandler(response);
			callback(false);
		});
	}

	deleteProductImage(productId, imageUrl, callback) {
		this.delete("/product/"+productId+"/productImage?imageUrl="+imageUrl, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});
				
			Dispatcher.dispatchAnAlert("Product Image deleted successfully.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

	publishUnpublishProduct(productId, publish, callback) {
		const str = publish === true? "publish": "unpublish";
		this.post("/product/"+productId + "/" + str, null, response => {

			Dispatcher.dispatch({
				type: ProductAction.LOAD_SINGLE_PRODUCT,
				product: response.data,
				productId: productId
			});
				
			Dispatcher.dispatchAnAlert("Product "+str+"ed successfully.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

	getFeaturedProductsForDashain() {
		this.get("/dashaincampaign/featuredproducts", response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS,
				products: response.data,
			});
		});
	}

	getRecentProducts(pageNumber, pageSize, callback) {
		const pgNumber = pageNumber || 0;
		const pgSize = pageSize || AppConstants.DEFAULT_PRODUCT_PAGE_SIZE;

		this.get("/product/recent?pageNumber="+pgNumber+"&pageSize="+pgSize, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_RECENT_PRODUCTS,
				products: response.data,
				nextPageNumber: pgNumber + 1,
				pageSize: pgSize
			});

			if(typeof callback === 'function')
				callback(response.data);
		});
	}

	getCreatorProducts(creator) {
		if(creator.storeName)
			this.getStoreProducts(creator.storeName);
		else
			this.getProducts(creator.id);
	}

	getProducts(userId) {
		this.get("/product/"+userId+"/list", response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_USER_PRODUCTS,
				products: response.data,
				userId: userId
			});
		});
	}

	getStoreProducts(storeName) {
		this.get("/product/store/"+storeName, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_STORE_PRODUCTS,
				products: response.data,
				storeName: storeName
			});
		});
	}

	getProductStat(productId) {
		this.get("/product/"+productId+"/productstat", response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_PRODUCT_STAT,
				productStat: response.data,
				productId: productId
			});
		});
	}

	deleteProduct(productId) {
		this.delete("/product/"+productId, response => {
			//TODO: dispatch  DELETE EVENT and redirect to home page too
			Dispatcher.dispatchAnAlert(response.data);
		});
	}

	getAllProducts(productState) {
		this.get("/product/list?productState="+productState, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_ALL_PRODUCTS,
				products: response.data,
				productState: productState
			});
		});
	}

	increaseCurrentTarget(productId, target, callback) {
		this.post("/product/"+productId+"/salesTarget/increase?target="+target, null, response => {
			Dispatcher.dispatchAnAlert("Your sales target is active and running.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

	getProductOrders(productId) {
		this.get("/product/"+productId+"/orders", response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_PRODUCT_ORDERS,
				orders: response.data,
				productId: productId
			});
		});
	}


	getAllOrders(orderStates) {
		this.get("/order/list?orderStates="+orderStates, response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_ALL_ORDERS_BY_STATE,
				orders: response.data,
				orderStates: orderStates
			});
		});
	}

	/** Dashain Campaign Orders */
	getDashainCampaignOrders() {
		this.get("/dashaincampaign/orders", response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS,
				orders: response.data
			});
		});
	}

	getMyOrders(orderStates) {
		this.get("/order/list/my", response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_USER_ORDERS,
				orders: response.data
			});
		});
	}

	getDesignerPendingOrders(userId) {
		let url = "/designer/orders/pending";

		if(userId)
			url += "?userId="+userId;

		this.get(url, response => {
			Dispatcher.dispatch({
				type: DesignerAction.LOAD_ALL_PENDING_ORDERS,
				orders: response.data
			});
		});
	}


	getOrderStat(){
		this.get("/order/stat", response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_ORDER_STAT,
				stat: response.data
			});
		});
	}

	getOrder(orderId) {
		this.get("/order/"+orderId, response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_SINGLE_ORDER,
				order: response.data
			});
		});
	}

	updateOrder(orderId, order, callback) {
		this.post("/order/"+orderId+"/update", order, response => {
			Dispatcher.dispatch({
				type: OrderAction.UPDATE_SINGLE_ORDER,
				order: response.data
			});

			Dispatcher.dispatchAnAlert("Order updated successfully.");
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

	getRedeemHistory() {
		this.get("/redeem/list", response => {
			Dispatcher.dispatch({
				type: RedeemAction.LOAD_REDEEM_HISTORY,
				redeemHistory: response.data
			});
		});
	}


	getDesignerBalance(userId) {
		let url = "/designer/balance";

		if(userId)
			url += "?userId="+userId;

		this.get(url, response => {
			Dispatcher.dispatch({
				type: DesignerAction.LOAD_BALANCE,
				balance: response.data
			});
		});
	}


	redeem(cachableSalesTargetId, sendToDetail, callback) {
		const postData = {
			toCashSalesTarget: cachableSalesTargetId,
			sendToDetail: sendToDetail
		};

		this.post("/redeem", postData, response => {
			Dispatcher.dispatch({
				type: RedeemAction.REDEEMED
			});

			Dispatcher.dispatchAnAlert(response.data);

			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}


	getPopularStores() {
		this.get("/user/stores/popular", response => {
			Dispatcher.dispatch({
				type: DesignerAction.LOAD_POPULAR_STORES,
				stores: response.data
			});
		});
	}

	bitlyShortenURL(longURL, onShorten) {
		const apiKey = AppConstants.BITLY_API_KEY;
		const apiLogin = AppConstants.BITLY_LOGIN;
		const apiUrl = "/shorten?login="+apiLogin+"&apiKey="+apiKey+"&longUrl="+longURL+"&format=json";

		BITLY_API.get(apiUrl).then(response => {
			onShorten(response.data.data.url);
		});
	}
}

export default new HttpService(AppConstants.BASE_API_URL);




// WEBPACK FOOTER //
// ./src/service/HttpService.js